import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AccountDetailView from '../../components/account'
// Actions
import * as actions from '../../store/actions'

const mapStateToProps = state => {
  return {
    account: state.crm.getAccountByIdResponse,
    accountRetrieving: state.crm.getAccountByIdRetrieving,
    accountError: state.crm.getAccountByIdError,
    allowDomainPurchasesResponse: state.crm.postAllowDomainPurchasesResponse,
    allowDomainPurchasesError: state.crm.postAllowDomainPurchasesError,
    allowMailPurchasesResponse: state.crm.postAllowMailPurchasesResponse,
    allowMailPurchasesError: state.crm.postAllowMailPurchasesError,
    postEmailChangeRetrieving: state.crm.postChangeEmailRetrieving,
    postEmailChangeResponse: state.crm.postChangeEmailResponse,
    postEmailChangeError: state.crm.postChangeEmailError,
    allowChangePaymentMethodResponse: state.crm.postAllowChangePaymentMethodResponse,
    allowChangePaymentMethodError: state.crm.postAllowChangePaymentMethodError,
    deleteAccountByIdRetrieving: state.crm.deleteAccountByIdRetrieving,
    synchronizeCardsRetrieving: state.crm.synchronizeCardsRetrieving,
    synchronizeCardsResponse: state.crm.synchronizeCardsResponse,
    synchronizeCardsError: state.crm.synchronizeCardsError,
    goodwillCredits: state.crm.getGoodwillCreditsForAccountResponse,
    restoreAccountSuccess: state.crm.restoreAccountResponse,
    restoreAccountPending: state.crm.restoreAccountRetrieving
  }
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatch
)(AccountDetailView)
